import css from './ChartCard.module.scss'

export default function ChartCard({ title = '', chart, children, w = 1 }) {
	return (
		<div
			className={css['box']}
			style={{ gridColumn: `span ${w}` }}
			//  style={{flexGrow: w}}
		>
			<h3>{title}</h3>
			{/* {chart} */}
			{children}
		</div>
	)
}
